import { combineReducers } from 'redux';
import {
    BROADCAST_LIST_FETCH_ERROR,
    BROADCAST_LIST_FETCH_IN_PROGRESS,
    BROADCAST_LIST_FETCH_SUCCESS,
    DELETE_DESTINATION_FETCH_ERROR,
    DELETE_DESTINATION_FETCH_IN_PROGRESS,
    DELETE_DESTINATION_FETCH_SUCCESS,
    FETCH_YOUTUBE_STATUS_ERROR,
    FETCH_YOUTUBE_STATUS_IN_PROGRESS,
    FETCH_YOUTUBE_STATUS_SUCCESS,
    GO_LIVE_FETCH_ERROR,
    GO_LIVE_FETCH_IN_PROGRESS,
    GO_LIVE_FETCH_SUCCESS,
    HIDE_LIVE_STREAM_DELETE_DIALOG,
    LIVE_STREAM_DESCRIPTION_SET,
    LIVE_STREAM_ID_SET,
    LIVE_STREAM_KEY_SET,
    LIVE_STREAM_SCHEDULE_END_DATE_SET,
    LIVE_STREAM_SCHEDULE_START_DATE_SET,
    LIVE_STREAM_SETUP_DIALOG_HIDE,
    LIVE_STREAM_SETUP_DIALOG_SHOW,
    LIVE_STREAM_SETUP_NAME_SET,
    LIVE_STREAM_SETUP_NODE_SET,
    LIVE_STREAM_THUMBNAIL_SET,
    LIVE_STREAM_VISIBILITY_SET,
    LIVE_VIDEOS_LIST_FETCH_ERROR,
    LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS,
    LIVE_VIDEOS_LIST_FETCH_SUCCESS,
    REMOVE_MEDIA_NODE_FETCH_ERROR,
    REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS,
    REMOVE_MEDIA_NODE_FETCH_SUCCESS,
    REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE,
    REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW,
    SCHEDULE_LIVE_SWITCH_SET,
    SELECTED_DESTINATIONS_LIST_SET,
    SET_STREAM_INFO_EMPTY,
    SHOW_LIVE_STREAM_DELETE_DIALOG,
    SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR,
    SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS,
    SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS,
    TV_LIVE_STREAM_ADD_ERROR,
    TV_LIVE_STREAM_ADD_IN_PROGRESS,
    TV_LIVE_STREAM_ADD_SUCCESS,
    TV_LIVE_STREAM_DELETE_SUCCESS,
    TV_LIVE_STREAM_FETCH_ERROR,
    TV_LIVE_STREAM_FETCH_IN_PROGRESS,
    TV_LIVE_STREAM_FETCH_SUCCESS,
    TV_LIVE_STREAM_PUBLISH_ERROR,
    TV_LIVE_STREAM_PUBLISH_IN_PROGRESS,
    TV_LIVE_STREAM_PUBLISH_SUCCESS,
    TV_LIVE_STREAM_UN_PUBLISH_ERROR,
    TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS,
    TV_LIVE_STREAM_UN_PUBLISH_SUCCESS,
    TV_LIVE_STREAM_UPDATE_ERROR,
    TV_LIVE_STREAM_UPDATE_IN_PROGRESS,
    TV_LIVE_STREAM_UPDATE_SUCCESS,
    TV_LIVE_STREAM_URL_FETCH_ERROR,
    TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS,
    TV_LIVE_STREAM_URL_FETCH_SUCCESS,
    TV_LIVE_STREAMS_FETCH_ERROR,
    TV_LIVE_STREAMS_FETCH_IN_PROGRESS,
    TV_LIVE_STREAMS_FETCH_SUCCESS,
    UPDATE_DESTINATIONS_FETCH_ERROR,
    UPDATE_DESTINATIONS_FETCH_IN_PROGRESS,
    UPDATE_DESTINATIONS_FETCH_SUCCESS,
    YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR,
    YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS,
    YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS,
    YOUTUBE_SETTINGS_TAB_SET,
} from '../../constants/mediaNodes/tv';
import { DEFAULT_SKIP, DEFAULT_TABLE_LIMIT } from '../../config';
import { MEDIA_NODE_EDIT_DIALOG_HIDE, MEDIA_NODE_EDIT_DIALOG_SHOW } from '../../constants/mediaNodes';

const streams = (state = {
    value: [],
    inProgress: false,
    skip: DEFAULT_SKIP,
    limit: DEFAULT_TABLE_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case TV_LIVE_STREAMS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case TV_LIVE_STREAMS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case TV_LIVE_STREAMS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const streamInfo = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case TV_LIVE_STREAM_FETCH_IN_PROGRESS:
    case TV_LIVE_STREAM_UPDATE_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case TV_LIVE_STREAM_FETCH_SUCCESS:
    case TV_LIVE_STREAM_UPDATE_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case TV_LIVE_STREAM_FETCH_ERROR:
    case TV_LIVE_STREAM_UPDATE_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_STREAM_INFO_EMPTY:
        return {
            ...state,
            value: {},
        };
    default:
        return state;
    }
};

const addStream = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case TV_LIVE_STREAM_ADD_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case TV_LIVE_STREAM_ADD_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case TV_LIVE_STREAM_ADD_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const url = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case TV_LIVE_STREAM_URL_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case TV_LIVE_STREAM_URL_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
            value: {},
        };
    default:
        return state;
    }
};

const publish = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case TV_LIVE_STREAM_PUBLISH_IN_PROGRESS:
    case TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case TV_LIVE_STREAM_PUBLISH_SUCCESS:
    case TV_LIVE_STREAM_UN_PUBLISH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case TV_LIVE_STREAM_PUBLISH_ERROR:
    case TV_LIVE_STREAM_UN_PUBLISH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

// setup live stream
const addLiveStreamDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_SETUP_DIALOG_SHOW:
        return {
            open: true,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case TV_LIVE_STREAM_ADD_SUCCESS:
        return {
            open: false,
        };
    default:
        return state;
    }
};

const deleteLiveStreamDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case SHOW_LIVE_STREAM_DELETE_DIALOG:
        return {
            ...state,
            open: true,
            value: action.value,
        };
    case HIDE_LIVE_STREAM_DELETE_DIALOG:
    case TV_LIVE_STREAM_DELETE_SUCCESS:
        return {
            ...state,
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const streamName = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_SETUP_NAME_SET:
        return {
            value: action.value,
            valid: action.valid,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW: {
        return {
            value: action.value?.name,
            valid: true,
        };
    }
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };
    default:
        return state;
    }
};

const streamNode = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_SETUP_NODE_SET:
        return {
            value: action.value,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW: {
        return {
            value: action.value?.media_node_id && [action.value.media_node_id],
        };
    }
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: '',
        };
    default:
        return state;
    }
};

const streamDescription = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_DESCRIPTION_SET:
        return {
            value: action.value,
            valid: action.valid,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW:
        return {
            value: action.value?.description,
            valid: true,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };
    default:
        return state;
    }
};

const streamThumbnail = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_THUMBNAIL_SET:
        return {
            value: action.value,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW:
        return {
            value: action.value?.thumbnail,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: '',
        };
    default:
        return state;
    }
};

const streamScheduleStartDate = (state = {
    value: null,
    valid: true,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_SCHEDULE_START_DATE_SET:
        return {
            value: action.value,
            valid: action.valid,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW:
        return {
            value: action.value?.scheduled_start_time,
            valid: true,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: null,
            valid: true,
        };
    default:
        return state;
    }
};

const streamScheduleEndDate = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_SCHEDULE_END_DATE_SET:
        return {
            value: action.value,
            valid: action.valid,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };
    default:
        return state;
    }
};

const streamVisibility = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_VISIBILITY_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const inputStreamId = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_ID_SET:
        return {
            ...state,
            value: action.value,
        };
    case TV_LIVE_STREAM_FETCH_SUCCESS:
        return {
            ...state,
            value: action.value && action.value._id,
        };

    default:
        return state;
    }
};

const inputStreamKey = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_KEY_SET:
        return {
            ...state,
            value: action.value,
        };
    case TV_LIVE_STREAM_FETCH_SUCCESS:
        return {
            ...state,
            value: action.value && action.value.stream_key,
        };

    default:
        return state;
    }
};

const liveVideosList = (state = {
    value: [],
    inProgress: false,
    skip: DEFAULT_SKIP,
    limit: DEFAULT_TABLE_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case LIVE_VIDEOS_LIST_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case LIVE_VIDEOS_LIST_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const scheduleLiveSwitch = (state = {
    value: false,
}, action) => {
    switch (action.type) {
    case SCHEDULE_LIVE_SWITCH_SET:
        return {
            value: action.value,
        };
    case MEDIA_NODE_EDIT_DIALOG_SHOW:
        return {
            value: !!action.value?.scheduled_start_time,
        };
    case LIVE_STREAM_SETUP_DIALOG_HIDE:
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            value: false,
        };
    default:
        return state;
    }
};

const broadcastList = (state = {
    value: [],
    inProgress: false,
    skip: DEFAULT_SKIP,
    limit: DEFAULT_TABLE_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case BROADCAST_LIST_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case BROADCAST_LIST_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case BROADCAST_LIST_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const youtubeSettingsTab = (state = {
    value: 'public',
}, action) => {
    switch (action.type) {
    case YOUTUBE_SETTINGS_TAB_SET:
        return {
            value: action.value,
        };
    default:
        return state;
    }
};

const selectedDestinationsList = (state = {
    value: [],
}, action) => {
    switch (action.type) {
    case SELECTED_DESTINATIONS_LIST_SET:
        return {
            value: action.value,
        };
    default:
        return state;
    }
};

const removeMediaNodeConfirmDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW:
        return {
            ...state,
            open: true,
            value: action.value,
        };
    case REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE:
        return {
            ...state,
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const removeMediaNode = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case REMOVE_MEDIA_NODE_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case REMOVE_MEDIA_NODE_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const updateDestinations = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case UPDATE_DESTINATIONS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case UPDATE_DESTINATIONS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case UPDATE_DESTINATIONS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const removeDestination = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case DELETE_DESTINATION_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case DELETE_DESTINATION_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case DELETE_DESTINATION_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const syncStudioLiveStream = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const youtubeAccessToken = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const goLive = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case GO_LIVE_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case GO_LIVE_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case GO_LIVE_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const liveFeedYoutubeStatus = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case FETCH_YOUTUBE_STATUS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_YOUTUBE_STATUS_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case FETCH_YOUTUBE_STATUS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

export default combineReducers({
    streams,
    streamInfo,
    addStream,
    url,
    publish,
    addLiveStreamDialog,
    deleteLiveStreamDialog,
    streamName,
    streamNode,
    streamDescription,
    streamThumbnail,
    streamScheduleStartDate,
    streamScheduleEndDate,
    streamVisibility,
    inputStreamId,
    inputStreamKey,
    liveVideosList,
    broadcastList,
    scheduleLiveSwitch,
    youtubeSettingsTab,
    selectedDestinationsList,
    removeMediaNodeConfirmDialog,
    removeMediaNode,
    updateDestinations,
    removeDestination,
    syncStudioLiveStream,
    youtubeAccessToken,
    goLive,
    liveFeedYoutubeStatus,
});
